import React from 'react';
import { Input } from '@marvelapp/ui';
export default function FormFieldHotspot(props) {
    var left = props.left, top = props.top, width = props.width, height = props.height, id = props.id;
    var style = {
        left: left,
        top: top,
        width: width,
        height: height,
        position: 'absolute',
    };
    return (React.createElement("div", { "data-testid": "hotspot-" + id, style: style },
        React.createElement(Input, { autoFocus: true, bg: "white", hasTransition: false, height: height, paddingLeft: "12px", pl: 36, size: 2, width: 1 })));
}
